import axios from 'axios';
import qs from 'qs';

export const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8888/api/admin';

const instance = axios.create({
  baseURL,
  transformRequest: [
    (data, headers) => {
      if (localStorage.getItem('token') && !headers.Authorization) {
        // eslint-disable-next-line no-param-reassign
        headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      }
      return JSON.stringify(data);
    },
  ],
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: params => qs.stringify(params),
});

export function login(username, password) {
  return instance.post('/login', { username, password });
}

export function list(resource, params) {
  return instance.get(`/${resource}`, { params });
}

export function one(resource, params) {
  return instance.get(`/${resource}/${params.id}`);
}

export function create(resource, params) {
  return instance.post(`/${resource}`, { ...params.data });
}

export function update(resource, params) {
  return instance.post(`/${resource}/${params.id}`, {
    _method: 'PUT',
    ...params.data,
  });
}

export function destroy(resource, params) {
  return instance.post(`/${resource}/${params.id}`, {
    _method: 'DELETE',
  });
}

export default instance;



// WEBPACK FOOTER //
// ./src/lib/api.js